<script lang="ts">
  import flagKeys from '../../etc/flagKeys';
  import { AppState } from '../../etc/stores';

  export let size: string | number = 20;
</script>

{#if $AppState.featureFlags.includes(flagKeys.NEW_COIN_ICON)}
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={$$props.style}
  >
    <path
      d="M4 7.0249V12.394C4 14.6182 7.58133 16.4209 12 16.4209C16.4187 16.4209 20 14.6182 20 12.394V7.0249"
      stroke={$$props.color || $AppState.theme.colors.primary400}
      stroke-width="1.5"
    />
    <path
      d="M4 12.3939V17.763C4 19.9872 7.58133 21.7898 12 21.7898C16.4187 21.7898 20 19.9872 20 17.763V12.3939"
      stroke={$$props.color || $AppState.theme.colors.primary400}
      stroke-width="1.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 11.0537C16.4183 11.0537 20 9.25081 20 7.02685C20 4.80288 16.4183 3 12 3C7.58172 3 4 4.80288 4 7.02685C4 9.25081 7.58172 11.0537 12 11.0537Z"
      stroke={$$props.color || $AppState.theme.colors.primary400}
      stroke-width="1.5"
      stroke-linecap="square"
    />
  </svg>
{:else}
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={$$props.style}
  >
    <path
      d="M9.83344 4.8335L11.2476 8.41928L14.8334 9.8335L11.2476 11.2477L9.83344 14.8335L8.41922 11.2477L4.83344 9.8335L8.41922 8.41928L9.83344 4.8335Z"
      fill={$$props.color || $AppState.theme.colors.primary400}
    />
    <circle
      cx="9.83331"
      cy="9.8335"
      r="8.25"
      stroke={$$props.color || $AppState.theme.colors.primary400}
      stroke-width="1.5"
    />
  </svg>
{/if}
